import { PROXY_SYM } from '../consts';
import { isPlainObject, isProduction } from '../utils';

const isProxy = <T>(obj: T): boolean =>
  !isProduction() && !!obj && !!~Object.getOwnPropertySymbols(obj).indexOf(PROXY_SYM);

const isProxiable = <T>(obj: T): boolean => Array.isArray(obj) || isPlainObject(obj);

export { isProxy, isProxiable };
